import WarningIcon from "components/dashboard/WarningIcon";
import React from "react";

import dashboard_header_image_1 from "_imgs/dashboard/dashboard_header_image-1.png"
import VSTTBanner from "_imgs/dashboard/VSTT-Banner.png"
import { Icon } from "@visa/vds";
import { PUBLIC_VSTT } from "./PageRoutes";

export const DASHBOARD_CAROUSEL_IMAGES = [
    { url: dashboard_header_image_1, title: "dashboard-header-1"},
    //{ url: VSTTBanner, title: "vstt-banner", link:PUBLIC_VSTT },
];

export const EXPIRATION_ALERT = {
    RED: 0,
    YELLOW: 1,
    BLACK: 2,
    BLUE: 3,
    NONE: 4,
};

export const VSTS_BUTTON_STATE = {
    ACTIVE: 0,
    EXPIRED: 1,
    NONE: 2
}


export const renderSubtitle = (currentCount, alertType, subtitles) => (currentCount == 0)
    ? <span>{subtitles.EMPTY}</span>
    : (alertType === CARD_ALERT_TYPE.NONE || alertType === CARD_ALERT_TYPE.BLUE)
        ? <span>{subtitles.NO_ALERT}</span>
        : <span>
            {ALERT_ICONS[alertType]} <span className="vertical-align-super">{subtitles.ALERT}</span>
        </span>


export const getExpirationAlertIcon = (expirationAlert) => {
    if (expirationAlert <= EXPIRATION_ALERT.BLUE) return ALERT_ICONS[expirationAlert]
    else return dateAlertPadding
}

export const getCardAlertType = (expirationAlert) => {
    return expirationAlert === CARD_ALERT_TYPE.RED
        ? CARD_ALERT_TYPE.RED
        : expirationAlert === CARD_ALERT_TYPE.YELLOW
            ? CARD_ALERT_TYPE.YELLOW
            : expirationAlert === CARD_ALERT_TYPE.BLACK
                ? CARD_ALERT_TYPE.BLACK
                : CARD_ALERT_TYPE.NONE
}
export const CARD_ALERT_TYPE = {
    RED: 0,
    YELLOW: 1,
    BLACK: 2,
    NONE: 3,
};

export const LINK_TYPE = {
    FILE: 1,
    URL: 2,
}


const WARNING_ICON_RED = <WarningIcon className="icon-vsts" />
const WARNING_ICON_YELLOW = <WarningIcon className="icon-vsts" color="#FFD900" />
const WARNING_ICON_BLACK = <WarningIcon className="icon-vsts" color="black" />
const WARNING_ICON_BLUE = <Icon className="icon-vsts" style={{ "height": "22px", "width": "22x" }} name="info" resolution="low" aria-label="info" />

export const ALERT_ICONS = [
    WARNING_ICON_RED,
    WARNING_ICON_YELLOW,
    WARNING_ICON_BLACK,
    WARNING_ICON_BLUE
]

const dateAlertPadding = "\u00A0".repeat(10)

export const DASHBOARD_STAFF_APPROVED_PRODUCT_TABLE_HEADERS = [
    {
        displayName: "Component",
        name: "Component",
        orderable: true,
    },
    {
        displayName: "Protocol Version",
        name: "ProtocolVersion",
        orderable: true,
    },
    {
        displayName: "Product Name",
        name: "ProductName",
        orderable: true,
    },
    {
        displayName: "Visa Compliance ID",
        name: "VisaCompId",
        orderable: true,
    },
    {
        displayName: "SCA",
        name: "Sca",
        orderable: false,
    },
    // {
    //     displayName: "DAF",
    //     name: "Daf",
    //     orderable: false,
    // },
    {
        displayName: "BME",
        name: "Bme",
        orderable: false,
    },
    {
        displayName: `${dateAlertPadding}Visa Expiration Date`,
        name: "ExpirationDate",
        orderable: true,
    },
]

export const DASHBOARD_USER_APPROVED_PRODUCT_TABLE_HEADERS = [
    {
        displayName: "Component",
        name: "Component",
        orderable: false,
    },
    {
        displayName: "Protocol Version",
        name: "ProtocolVersion",
        orderable: false,
    },
    {
        displayName: "Product Name",
        name: "ProductName",
        orderable: false,
    },
    {
        displayName: "Visa Compliance ID",
        name: "VisaCompId",
        orderable: false,
    },
    {
        displayName: "SCA",
        name: "Sca",
        orderable: false,
    },
    // {
    //     displayName: "DAF",
    //     name: "Daf",
    //     orderable: false,
    // },
    {
        displayName: "BME",
        name: "Bme",
        orderable: false,
    },
    {
        displayName: `${dateAlertPadding}Visa Expiration Date`,
        name: "ExpirationDate",
        orderable: false,
    },
]

export const DASHBOARD_USER_VSTS_SUBSCRIPTION_TABLE_HEADERS = [
    {
        displayName: "VSTS Subscription",
        name: "SubscriptionName",
        orderable: false,
    },
    {
        displayName: "Start Date",
        name: "StartDate",
        orderable: false,
    },
    {
        displayName: `${dateAlertPadding}End Date`,
        name: "EndDate",
        orderable: false,
    },
]

export const DASHBOARD_STAFF_VSTS_SUBSCRIPTION_TABLE_HEADERS = [
    {
        displayName: "VSTS Subscription",
        name: "SubscriptionName",
        orderable: false,
    },
    {
        displayName: "Start Date",
        name: "StartDate",
        orderable: false,
    },
    {
        displayName: `${dateAlertPadding}End Date`,
        name: "EndDate",
        orderable: false,
    },
]

export const DASHBOARD_STAFF_VSTT_SUBSCRIPTION_TABLE_HEADERS = [
    {
        displayName: `${dateAlertPadding}VSTT Subscription`,
        name: "VsttSubscription",
        orderable: false,
    },
    {
        displayName: "Subscription Type",
        name: "SubscriptionType",
        orderable: false,
    },
]

export const DASHBOARD_USER_VSTT_SUBSCRIPTION_TABLE_HEADERS = [
    {
        displayName: `${dateAlertPadding}VSTT Subscription`,
        name: "VsttSubscription",
        orderable: false,
    },
    {
        displayName: "Subscription Type",
        name: "SubscriptionType",
        orderable: false,
    },
]

export const DASHBOARD_CERTIFICATION_PACKAGE_TABLE_HEADERS = [
    {
        displayName: "ID",
        name: "id",
        orderable: true
    },
    {
        displayName: "Name",
        name: "packageName",
        orderable: true
    },
    {
        displayName: "Implementation Type",
        name: "implementationType",
        orderable: true
    },
    {
        displayName: "Created On",
        name: "createdOn",
        orderable: true
    },
    {
        displayName: "Updated On",
        name: "lastUpdatedOn",
        orderable: true
    },
    {
        displayName: "Package Status",
        name: "packageStateDisplayName",
        orderable: false
    },
    {
        displayName: "",
        name:"",
        orderable: false
    }
]

export const APPROVED_PRODUCT_TITLE = "Approved Products"
export const APPROVED_PRODUCT_SUBTITLES = {
    EMPTY: "No Approved Product",
    ALERT: "Certification Renewal(s)",
    NO_ALERT: "Approved Product(s)"
}

export const VSTS_TITLE = "Visa Secure Test Suite (VSTS) Subscription Access"
export const VSTS_SUBTITLES = {
    EMPTY: "No Subscription",
    ALERT: "Purchased Subscription(s)",
    NO_ALERT: "Purchased Subscription(s)"
}

export const VSTT_TITLE = "Visa Secure Test Tool (VSTT) Subscriptions"
export const VSTT_SUBTITLES = {
    EMPTY: "No Subscription",
    ALERT: "Active Subscription(s)",
    NO_ALERT: "Active Subscription(s)"
}

export const CERTIFICATION_PACKAGE_TITLE = "Certification Packages"
export const CERTIFICATION_PACKAGE_SUBTITLES = {
    INACTIVE_DEACTIVATED: "INACTIVE (DEACTIVATED)",
    INACTIVE_PAYMENTREQUIRED: "INACTIVE (PAYMENT PENDING)",
    INACTIVE_NOSUBSCRIPTION: "INACTIVE (NO SUBSCRIPTION PURCHASED)",
    INACTIVE_FUTURESTARTDATE: "INACTIVE (FUTURE START DATE)",
    INACTIVE_ACCESSPENDING: "INACTIVE (SUBSCRIPTION PAID, ACCESS PENDING",
    ACTIVE: "ACTIVE",
    ACTIVE_EXPIRING: "ACTIVE (EXPIRING ON",
}

